import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={30}
    height={31}
    viewBox="0 0 30 31"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#2D27F6'}
      fillRule="evenodd"
      d="M8.83 6.337c3.09-2.05 4.08-2.65 5.07-2.86.84-.18 1.71-.18 2.55 0 .99.22 1.98.82 5.07 2.86 2.75 1.82 3.59 2.41 4.14 3.15.47.62.82 1.32 1.02 2.08.24.89.2 1.92-.04 5.21-.18 2.44-.3 4.11-.5 5.39-.2 1.26-.44 1.93-.74 2.41a6.08 6.08 0 0 1-2.39 2.22c-.5.26-1.19.45-2.45.56-1.3.11-2.96.11-5.4.11-2.44 0-4.1 0-5.4-.11-1.26-.11-1.95-.3-2.45-.56a6.15 6.15 0 0 1-2.39-2.22c-.3-.48-.54-1.15-.74-2.41-.2-1.29-.32-2.96-.5-5.39-.24-3.3-.28-4.33-.04-5.21.2-.75.55-1.46 1.02-2.08.56-.73 1.39-1.33 4.14-3.15h.03Zm-7.7 10.62c-.23-3.11-.34-4.66.04-6.08.29-1.07.79-2.08 1.46-2.97.88-1.16 2.18-2.02 4.77-3.74 2.91-1.93 4.37-2.89 5.95-3.23a8.59 8.59 0 0 1 3.64 0c1.58.34 3.04 1.31 5.95 3.23 2.59 1.71 3.89 2.57 4.77 3.74.67.89 1.17 1.89 1.46 2.97.38 1.41.27 2.97.04 6.08-.34 4.79-.52 7.18-1.61 8.96-.82 1.35-2 2.45-3.41 3.17-1.86.96-4.25.96-9.04.96-4.79 0-7.18 0-9.04-.96a8.599 8.599 0 0 1-3.41-3.17c-1.09-1.78-1.26-4.18-1.61-8.96h.04Zm10.82 3.83c-.6 0-1.08.48-1.08 1.08 0 .6.48 1.08 1.08 1.08h6.46c.59 0 1.08-.48 1.08-1.08 0-.6-.48-1.08-1.08-1.08h-6.46Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default SvgComponent;
